import React from "react";
import moment from "moment";
import { Button, Col, Row, TabPane } from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import ModalQuoteDetail from "../modals/ModalQuoteDetail";
import Money from "../components/Money";

export default function CurrentQuotes({
  quotations,
  loading,
  modalIsOpen,
  selectedQuotation,
  servicesSeleted,
  onSelectQuotation,
  onCloseQuotation,
  onSelectService,
  onAddServices,
  isPageModalHistory,
}) {
  return (
    <TabPane tabId={2}>
      <div className="animated fadeIn">
        <ModalQuoteDetail
          isOpen={modalIsOpen}
          quotation={selectedQuotation}
          servicesSeleted={servicesSeleted}
          onClose={onCloseQuotation}
          onSelectService={onSelectService}
          onAddServices={onAddServices}
        />
        <Row form>
          <Col>
            <ReactTable
              data={quotations}
              defaultPageSize={5}
              loading={loading}
              loadingText="Cargando..."
              noDataText="No hay cotizaciones vigentes"
              className="-striped -highlight"
              columns={[
                {
                  Header: "Fecha",
                  className: "text-center",
                  Cell: ({ original }) =>
                    moment(original?.date).format("DD/MM/YYYY"),
                },
                {
                  Header: "Cotización",
                  className: "text-center",
                  accessor: "code",
                },
                {
                  Header: "Valor",
                  className: "text-right",
                  Cell: ({ original }) => <Money value={original?.total} />,
                },
                {
                  Header: "Opciones",
                  className: "text-center",
                  show: !isPageModalHistory,
                  Cell: ({ original }) => (
                    <Button
                      type="button"
                      color="success"
                      className="btn-color-success card-header-action"
                      onClick={() => onSelectQuotation(original)}
                    >
                      <i className="fa fa-check" aria-hidden="true" />
                      {" Seleccionar"}
                    </Button>
                  ),
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    </TabPane>
  );
}
